export default __webpack_public_path__ + "static/portfolio-b2569424a24e7d2c7f2bb09297c97acd.webm";